module.exports = __webpack_public_path__ + "static/1-199459afe5470e37e058f2605ab9b809.jpeg";